/**
 * App Router Configuration
 *
 * Defines all routes for the public website
 * Phase 4: Public Frontend Routes
 */

import { Routes, Route } from 'react-router-dom';
import { PublicLayout } from './components/layout/PublicLayout';

// Pages
import { HomePage } from './pages/HomePage';
import { CategoriesPage } from './pages/CategoriesPage';
import { CategoryPage } from './pages/CategoryPage';
import { ProductPage } from './pages/ProductPage';
import { AboutPage } from './pages/AboutPage';
import { FAQPage } from './pages/FAQPage';
import { ContactPage } from './pages/ContactPage';
import { SearchResultsPage } from './pages/SearchResultsPage';

// Policy Pages
import { PrivacyPolicyPage } from './pages/policies/PrivacyPolicyPage';
import { TermsPage } from './pages/policies/TermsPage';
import { ShippingPage } from './pages/policies/ShippingPage';
import { RefundPage } from './pages/policies/RefundPage';

// New Pages (auth overhaul)
import { TrackInquiryPage } from './pages/TrackInquiryPage';
import { InquiryBasketPage } from './pages/InquiryBasketPage';
import { ShortlistPage } from './pages/ShortlistPage';

// Protected Pages
import { ProtectedRoute } from './components/common/ProtectedRoute';
import { CataloguePage } from './pages/CataloguePage';
import { InquiryListPage } from './pages/protected/InquiryListPage';
import { InquiryDetailPage } from './pages/protected/InquiryDetailPage';

// Old imports commented out for auth overhaul — easy re-enable
// import { LoginPage } from './pages/public/LoginPage';
// import { OAuthCallbackPage } from './pages/public/OAuthCallbackPage';
// import { BulkOrderPage } from './pages/protected/BulkOrderPage';

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicLayout />}>
        {/* Main Pages */}
        <Route path="/" element={<HomePage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/categories/:slug" element={<CategoryPage />} />
        <Route path="/products/:slug" element={<ProductPage />} />
        <Route path="/search" element={<SearchResultsPage />} />

        {/* Static Pages */}
        <Route path="/about" element={<AboutPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/catalogue" element={<CataloguePage />} />

        {/* Policy Pages */}
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/shipping" element={<ShippingPage />} />
        <Route path="/refund" element={<RefundPage />} />

        {/* New Public Pages (auth overhaul) */}
        <Route path="/track-inquiry" element={<TrackInquiryPage />} />
        <Route path="/inquiry-basket" element={<InquiryBasketPage />} />
        <Route path="/shortlist" element={<ShortlistPage />} />

        {/* Protected User Pages */}
        <Route
          path="/inquiries"
          element={
            <ProtectedRoute>
              <InquiryListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/inquiries/:id"
          element={
            <ProtectedRoute>
              <InquiryDetailPage />
            </ProtectedRoute>
          }
        />

        {/* Old routes commented out for auth overhaul — easy re-enable */}
        {/* <Route path="/login" element={<LoginPage />} /> */}
        {/* <Route path="/auth/callback/:provider" element={<OAuthCallbackPage />} /> */}
        {/* <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} /> */}
        {/* <Route path="/bulk-order" element={<ProtectedRoute><BulkOrderPage /></ProtectedRoute>} /> */}
        {/* <Route path="/wishlist" element={<ProtectedRoute><WishlistPage /></ProtectedRoute>} /> */}
      </Route>
    </Routes>
  );
}

export default App;
